import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";

export default class FindIneligibleFFormMDP extends FFormMDP {
  parent: any;
  childMDP: FFormChildMDP = new FFormChildMDP();

  constructor(props: { parent: any }) {
    super({ myRefName: "FindIneligibleRef" });
    this.parent = props.parent;

    this.addField(
      new FPhoneFieldMDP({
        dataSelectorKey: "customerPhoneNumber",
        label: "Customer PhoneNumber",
        parentMDP: this.childMDP,
      }),
    ).addAction(
      new FFormSubmitBtnMDP({
        label: "view details",
        onClick: () => {
          props.parent.getIneilgibleDashboard();
        },
      }),
    );
  }
}
